<template>
  <!-- enter ammount -->
  <div class="wrapper -mt-4 lg:mt-8">
    <!-- available balance -->
    <div v-if="fromBalance" class="px-10">
      <p class="font-normal text-root-4 text-xs md:text-sm">
        Available Balance
      </p>
      <h4 class="text-lg md:text-2xl mt-1">{{ parseMoney(totalBalance) }}</h4>
    </div>
    <div>
      <el-form
        :model="enteredAmountForm"
        ref="enteredAmountForm"
        :rules="rules"
        size="normal"
      >
        <div class="mt-4 grid grid-cols-12 form-item bg-root">
          <div class="flex flex-col col-span-8 md:col-span-8 px-5">
            <label class="font-normal text-root-3 text-xs mt-3 lg:mb-2"
              >I want to Send {{ country.currency }}
              {{ parseNetworkName(country.network) || '' }}</label
            >
            <div class="flex items-center pt-0 lg:pb-1">
              <span
                v-if="fromBalance"
                class="text-root-3 pb-5 text-xl md:text-3xl"
                >$</span
              >
              <span v-else class="text-root-3 text-xl md:text-3xl pb-5">{{
                country.symbol
              }}</span>
              <el-form-item prop="enteredAmount">
                <el-input
                  @input="calcFirstInput"
                  class="text-lg md:text-xl"
                  v-model="enteredAmountForm.enteredAmount"
                  name="amount"
                  placeholder="0.00"
                  :readonly="hasBeenDebited"
                >
                </el-input
              ></el-form-item>
            </div>
          </div>
          <div
            class="col-span-4 md:col-span-4 flex items-center justify-center drop-down"
          >
            <div
              class="font-light text-xs flex items-center justify-center gap-x-2 bg-root-2 px-4 py-2 -mr-4 cursor-pointer rounded-lg transition-all duration-150 hover:shadow"
              v-on="
                !hasBeenDebited ? { click: () => openDialog('source') } : {}
              "
            >
              <currency-icon :currency="country.name" />
              <div class="capitalize">{{ country.currency }}</div>
              <arrow-down />
            </div>
            <!-- <span
              v-if="fromBalance"
              class="el-dropdown-link flex items-center gap-3"
            >
              <u-s-a-flag />
              <h4 class="text-lg font-bold">USD</h4>
            </span> -->

            <!-- <span v-else class="flex items-center">
              <div class="">
                <local-flag-icon v-if="!transferSourceIsGlobalFiat" />
                <u-s-a-flag v-else />
              </div> -->
            <!-- <h4 class="text-lg font-bold">{{country.currency}}</h4> -->
            <!-- <el-select v-model="activeCurrency" @change="changeActiveCountry">
                <el-option
                  class=""
                  v-for="item in currencyOptions"
                  :key="item.currency"
                  :label="item.currency"
                  :value="item.name"
                >
                  <div class="flex">
                    <span class="pr-2" style="float: left">{{
                      item.currency
                    }}</span>
                    -
                    <span
                      class="pl-2"
                      style="float: right; color: #8492a6; font-size: 13px"
                      >{{ item.currencyFull }}</span
                    >
                  </div>
                </el-option>
              </el-select> -->
            <!-- </span> -->
          </div>
        </div>

        <transition name="slide-fade">
          <div v-if="showPendingAsset">
            <div class="flex items-center justify-center my-4 relative">
              <div @click="switchCurrency" class="cursor-pointer z-10">
                <switch-icon />
              </div>
              <!-- vertical like line -->
              <div
                class="w-0.5 h-16 rounded-sm bg-root-3 absolute left-1/2"
              ></div>
            </div>
            <div class="grid grid-cols-12 form-item bg-root">
              <div class="flex flex-col col-span-8 px-5">
                <label class="font-normal text-root-3 text-xs mt-3 lg:mb-2"
                  >Recipient will get {{ country2.currency }}</label
                >

                <div class="flex items-center pt-0 lg:pb-1">
                  <span class="text-root-3 pb-5 text-xl md:text-3xl">{{
                    country2.symbol
                  }}</span>
                  <el-form-item prop="recipientAmount">
                    <el-input
                      v-if="transferTypeSelected === 'fromBalance'"
                      v-model="recipientAmountBalance"
                      :readonly="hasBeenDebited"
                    ></el-input>
                    <el-input
                      v-else
                      @input="calcSecondInput"
                      v-model="enteredAmountForm.recipientAmount"
                      placeholder="0.00"
                      :readonly="hasBeenDebited"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div
                class="col-span-4 flex items-center justify-center drop-down"
              >
                <div
                  class="font-light text-xs flex items-center justify-center gap-x-2 bg-root-2 px-4 py-2 -mr-4 cursor-pointer rounded-lg transition-all duration-150 hover:shadow"
                  @click="openDialog('destination')"
                >
                  <currency-icon :currency="country2.name" />
                  <div class="capitalize">{{ country2.currency }}</div>
                  <arrow-down />
                </div>
              </div>
            </div>

            <!-- <p
              class="text-xs md:text-sm text-root-4 font-normal my-4 text-center"
            >
              Duration: Should arrive between 1-3 business days
            </p> -->
            <div
              class="form-item mt-5 px-10 py-4 text-xs text-root-4 font-normal"
            >
              <ul>
                <li class="flex items-center justify-between mb-3">
                  <span>Exchange rate</span>
                  <span class="text-root-2 font-medium"
                    >1
                    {{
                      !this.isDivisionOperator
                        ? country.currency
                        : country2.currency
                    }}
                    = {{ exchangeRateBase }}
                    {{
                      !this.isDivisionOperator
                        ? country2.currency
                        : country.currency
                    }}</span
                  >
                </li>
                <li class="flex items-center justify-between mb-3">
                  <span
                    >Our fees {{ percentageFees || ''
                    }}{{ percentageFees ? '%' : '' }}
                  </span>
                  <span class="text-root-2 font-medium">{{
                    parseMoneyAll(fees, country.currency)
                  }}</span>
                </li>
                <li
                  v-if="!fromBalance && transferSourceIsLocal"
                  class="flex items-center justify-between mb-3"
                  @click="editCommission"
                >
                  <span class="flex items-center gap-x-1 cursor-pointer"
                    ><span>Partner's commission </span>
                  </span>
                  <span
                    class="text-root-2 font-medium flex items-center gap-x-1"
                    @click="editCommission"
                    >{{ parseMoneyAll(partnerCommission, country.currency)
                    }}<edit-pen-icon
                  /></span>
                </li>
                <li class="flex items-center justify-between mb-3">
                  <span>Total amount we'll convert</span>
                  <span class="text-root-2 font-medium">{{
                    firstInputSelected
                      ? parseMoneyAll(
                          formatAmount(enteredAmountForm.enteredAmount) - fees,
                          country.currency
                        )
                      : parseMoneyAll(
                          formatAmount(enteredAmountForm.recipientAmount) /
                            exchangeRate,
                          country.currency
                        )
                  }}</span>
                </li>
              </ul>
            </div>
            <!-- continue button -->
            <div class="continue-button w-full mt-8">
              <o-button
                :disabled="
                  !enteredAmountForm.enteredAmount ||
                  (fromBalance &&
                    formatAmount(enteredAmountForm.enteredAmount) >
                      this.totalBalance) ||
                  (!fromBalance && !recipientAmount)
                "
                @click="validateForm('enteredAmountForm')"
                class="text-white"
              >
                {{ 'Continue' }}</o-button
              >
            </div>
          </div>
        </transition>
        <!-- pending transfers -->
        <!-- <pending-asset-transfers
          v-if="!enteredAmountForm.enteredAmount"
          @showDebitedAmount="showDebitedAmountFlow"
          @showMakePayment="goToMakePayment"
        /> -->
      </el-form>
    </div>
    <!-- commission setting dialog -->
    <edit-partner-commission-dialog
      v-if="showPartnerCommissionDialog"
      :showDialog="showPartnerCommissionDialog"
      @closeDialog="closeDialog('showPartnerCommissionDialog')"
    />
    <!-- transfer reason dialog -->
    <transfer-reason-dialog
      v-if="showTransferReasonDialog"
      :showDialog="showTransferReasonDialog"
      @closeDialog="closeDialog('showTransferReasonDialog')"
      @next="next"
    />
    <select-currency
      v-if="showSelectCurrencyDialog"
      :showDialog="showSelectCurrencyDialog"
      :currencyType="currencyType"
      :inputEmpty="!enteredAmountForm.enteredAmount"
      @closeDialog="closeDialog('showSelectCurrencyDialog')"
    />
    <pending-asset-transfer
      v-if="showPendingAssetTransferDialog"
      :showDialog="showPendingAssetTransferDialog"
      @showDebitedAmount="showDebitedAmountFlow"
      @closeDialog="closeDialog('showPendingAssetTransferDialog')"
    />
    <terminal-restricted v-if="!hasKyc" :showDialog="!hasKyc" />
  </div>
</template>

<script>
import {
  FormatAmount,
  AddComma,
  ParseMoneyAll,
  ParseMoney,
  ParseNetworkName
} from '@/utils/helpers'
import { COUNTRIES, LOCAL_COUNTRIES } from '@/utils/constants'
import localDeposit from '@/mixins/localDeposit.js'
import getBalance from '@/mixins/getBalance.js'
import country from '@/mixins/getCountryDetails.js'
import getPendingDeposits from '@/mixins/pendingDeposit.js'
import hasKyc from '@/mixins/app.js'
export default {
  mixins: [localDeposit, country, getBalance, getPendingDeposits, hasKyc],
  components: {
    EditPenIcon: () => import('@/assets/icons/EditPenIcon.vue'),
    // InfoIcon: () => import('@/assets/icons/InfoIcon.vue'),
    // USAFlag: () => import('@/assets/icons/USAFlag.vue'),
    ArrowDown: () => import('@/assets/icons/ArrowDownIconTwo.vue'),
    SwitchIcon: () => import('@/assets/icons/SwitchIcon.vue'),
    // PendingAssetTransfers: () =>
    //   import('@/components/terminal/terminalSkeleton/PendingTransfer.vue'),
    // NigeriaFlag: () => import('@/assets/icons/NigeriaFlag.vue'),
    // LocalFlagIcon: () => import('@/assets/icons/LocalFlagIcon.vue'),
    // LocalFlagIcon2: () => import('@/assets/icons/LocalFlagIcon2.vue'),
    TransferReasonDialog: () => import('../TransferReasonDialog.vue'),
    PendingAssetTransfer: () =>
      import('@/components/terminal/dialogs/PendingAssetTransfer.vue'),
    CurrencyIcon: () => import('@/assets/icons/CurrencyIcons.vue'),
    EditPartnerCommissionDialog: () =>
      import('@/components/terminal/EditPartnerCommissionDialog.vue'),
    SelectCurrency: () =>
      import('@/components/terminal/dialogs/SelectCurrency.vue'),
    TerminalRestricted: () =>
      import('@/components/terminal/dialogs/TerminalRestricted.vue')
  },
  data () {
    return {
      currencyOptions: COUNTRIES,
      localCurrencyOptions: LOCAL_COUNTRIES,
      showPartnerCommissionDialog: false,
      showSelectCurrencyDialog: false,
      showTransferReasonDialog: false,
      showPendingAssetTransferDialog: false,
      showPendingAssetTransfer: false,
      firstInputSelected: true,
      switchRecipientAmount: 0,
      showRecipientField: false,
      currencyType: '',
      enteredAmountForm: {
        enteredAmount: '',
        recipientAmount: ''
      },
      rules: {
        enteredAmount: [
          { validator: this.validateAmount, trigger: ['blur', 'change'] }
        ],
        recipientAmount: [
          {
            validator: this.validateRecipientAmount,
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  computed: {
    showPendingAsset () {
      return this.enteredAmountForm.enteredAmount || this.showRecipientField
    },
    computeShowPendingAssetTransfer () {
      return this.showPendingAssetTransfer
    },
    walletAddresses () {
      return this.$store.state.transactions.walletAddresses.items || []
    },
    transferable () {
      const transferDetails = this.$store.state.auth.transferDetails
      const details = transferDetails.find(
        (detail) =>
          detail.from === this.secondaryCurrency &&
          detail.to === this.activeCurrency
      )
      const walletDetails = this.walletAddresses.find(
        (wallet) =>
          wallet.asset === this.secondaryCurrency &&
          wallet.reason === 'transfer'
      )
      if (this.transferDestinationIsAsset && !walletDetails) {
        return false
      }
      return details?.is_enabled
    },
    hasBeenDebited () {
      return this.$store.state.terminal.hasBeenDebited
    },
    inputAmountFieldIsNotEmpty () {
      return (
        this.enteredAmountForm.enteredAmount &&
        this.enteredAmountForm.recipientAmount &&
        this.enteredAmountForm.enteredAmount !== ''
      )
    },
    partnerCommission () {
      return (
        parseInt(
          this.$store.state.terminal.transferTerminalDetails?.transferDetails
            ?.partnerCommission
        ) || 0
      )
    },
    fees () {
      if (this.enteredAmountForm.enteredAmount) {
        if (this.percentageFees) {
          return (
            (this.percentageFees / 100) *
            FormatAmount(this.enteredAmountForm.enteredAmount)
          ).toFixed(2)
        } else if (this.flatFees) {
          return this.flatFees
        } else {
          return 0
        }
      } else {
        return 0
      }
    },
    // activeCurrency: {
    //   get: function () {
    //     return this.$store.state.common.activeCountry
    //   },
    //   set: function (newValue) {
    //     this.$store.dispatch('common/setActiveCountry', newValue)
    //   }
    // },
    // secondaryCurrency: {
    //   get: function () {
    //     return this.$store.state.common.secondaryCountry
    //   },
    //   set: function (newValue) {
    //     this.$store.dispatch('common/setSecondaryCountry', newValue)
    //   }
    // },
    recipientAmount: function () {
      const charges = this.fees
      const exchangedAmount =
        (FormatAmount(this.enteredAmountForm.enteredAmount) - charges) *
        this.exchangeRate
      if (!exchangedAmount || exchangedAmount <= 0) {
        return 0
      }
      return AddComma(parseFloat(exchangedAmount).toFixed(2).toString())
    },
    enteredAmount: function () {
      const amountToConvert =
        FormatAmount(this.enteredAmountForm.recipientAmount) / this.exchangeRate
      const exchangedAmount = this.percentageFees
        ? amountToConvert / (1 - this.percentageFees / 100)
        : amountToConvert + this.flatFees
      if (!exchangedAmount || exchangedAmount <= 0) {
        return AddComma(parseFloat(0).toString())
      }
      return AddComma(parseFloat(exchangedAmount).toFixed(2).toString())
    },
    recipientAmountBalance: function () {
      const exchangedAmount =
        FormatAmount(this.enteredAmountForm.enteredAmount) - this.fees
      return parseFloat(exchangedAmount)
    },
    transferTypeSelected () {
      return this.$store.state.terminal.terminalTransferType
    },
    transferDetails () {
      return (
        this.$store.state.terminal.transferTerminalDetails.transferDetails || {}
      )
    },
    fromBalance () {
      return this.$store.state.terminal.terminalTransferType === 'fromBalance'
    }
  },
  methods: {
    showDebitedAmountFlow () {
      const debit = this.transferDetails.debitAmount
      this.enteredAmountForm.enteredAmount = debit
      this.openDialog('destination')
    },
    goToMakePayment () {
      this.$emit('showMakePayment')
    },
    async switchCurrency () {
      const vm = this
      if (this.transferable && !this.hasBeenDebited) {
        const activeCountry = this.country.name
        const secondaryCountry = this.country2.name
        this.$store.dispatch('common/setSecondaryCountry', activeCountry)
        this.$store.dispatch('common/setActiveCountry', secondaryCountry)
        if (this.inputAmountFieldIsNotEmpty) {
          this.switchRecipientAmount = this.enteredAmountForm.recipientAmount
          await this.calcSecondInput()
          this.switchRecipientAmount = 0
          this.$nextTick(() => {
            this.calcFirstInput()
          })
        }
      } else {
        vm.$message({
          showClose: true,
          message: `Can't transfer from ${this.secondaryCurrency}  to ${this.activeCurrency} at the moment`,
          type: 'info'
        })
      }
    },
    parseNetworkName (networkType) {
      return ParseNetworkName(networkType)
    },
    calcFirstInput () {
      this.firstInputSelected = true
      this.calculate()
    },
    calcSecondInput () {
      this.firstInputSelected = false
      this.calculate()
    },
    calculate () {
      if (this.firstInputSelected) {
        this.enteredAmountForm.recipientAmount = this.recipientAmount
      } else {
        this.enteredAmountForm.enteredAmount =
          this.switchRecipientAmount || this.enteredAmount
      }
    },
    changeSecondaryCountry () {
      if (this.inputAmountFieldIsNotEmpty) {
        this.calcSecondInput()
      }
      this.$store.dispatch('common/setSecondaryCountry', this.secondaryCurrency)
    },
    getBeneficiaries () {
      const vm = this
      this.$store
        .dispatch('terminal/getBeneficiaries')
        .then(() => {})
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
    },
    changeActiveCountry () {
      if (this.inputAmountFieldIsNotEmpty) {
        this.calcFirstInput()
      }
      if (this.activeCurrency !== this.$store.state.common.activeCountry) {
        this.$store.dispatch('common/setActiveCountry', this.activeCurrency)
      }
      this.$store.dispatch(
        'common/setSecondaryCountry',
        this.$store.state.common.secondaryCountry === 'usa'
          ? 'nigeria'
          : this.secondaryCurrency
      )
    },
    editCommission () {
      this.showPartnerCommissionDialog = true
    },
    formatAmount (val) {
      return FormatAmount(val)
    },
    validateAmount (rule, value, callback) {
      const totalDebitAmount = FormatAmount(value)
      if (totalDebitAmount < 10) {
        callback(new Error(`Minimum amount is ${this.country.symbol}10`))
      }
      if (totalDebitAmount > 9999999999) {
        callback(
          new Error(
            `Maximum amount is ${this.country.symbol} ${AddComma('9999999999')}`
          )
        )
      }
      if (totalDebitAmount > this.totalBalance && this.fromBalance) {
        callback(new Error("That's more than your balance"))
      } else if (!totalDebitAmount) {
        callback(new Error('Provide an amount'))
      } else {
        callback()
      }
    },
    validateRecipientAmount (rule, value, callback) {
      const toReceiveAmount = FormatAmount(value)
      if (toReceiveAmount < 10) {
        callback(new Error(`Minimum amount is ${this.country2.symbol}10`))
      }
      if (toReceiveAmount > 9999999999) {
        callback(
          new Error(
            `Maximum amount is ${
              !this.transferSourceIsGlobalFiat ? '$' : this.country2.symbol
            } ${AddComma('9999999999')}`
          )
        )
      }
      if (toReceiveAmount > this.totalBalance && this.fromBalance) {
        callback(new Error("That's more than your balance"))
      } else if (!toReceiveAmount) {
        callback(new Error('Provide an amount'))
      } else {
        callback()
      }
    },
    parseMoneyAll (val, currency) {
      return ParseMoneyAll(val, currency)
    },
    parseMoney (val) {
      ParseMoney(val)
    },
    next (transferReason) {
      const details = {
        transferReason: transferReason,
        debitAmount: FormatAmount(this.enteredAmountForm.enteredAmount),
        fees: this.fees,
        recipientAmount: this.fromBalance
          ? this.recipientAmountBalance
          : AddComma(
              parseFloat(FormatAmount(this.recipientAmount))
                .toFixed(2)
                .toString()
            ),
        partnerCommission:
          !this.transferSourceIsGlobalFiat && !this.transferSourceIsAsset
            ? this.partnerCommission
            : 0
      }
      this.$store.dispatch('terminal/setTransferDetails', details)
      this.$emit('next')
    },
    validateForm (enteredAmountForm) {
      this.$refs[enteredAmountForm].validate((valid) => {
        if (valid) {
          this.continueHandler()
        } else {
          this.$notify.error({
            title: 'Invalid input',
            message: 'Provide a valid amount',
            position: 'top-right'
          })
        }
      })
    },
    continueHandler () {
      this.showTransferReasonDialog = true
    },
    openDialog (type) {
      if (type === 'source') {
        this.showRecipientField = true
      }
      this.currencyType = type
      this.showSelectCurrencyDialog = true
    },
    closeDialog (dialog) {
      this[dialog] = false
      if (dialog === 'showPartnerCommissionDialog') return
      if (
        this.enteredAmountForm.enteredAmount <= 0 ||
        this.enteredAmountForm.enteredAmount === ''
      ) {
      } else {
        this.firstInputSelected = this.currencyType === 'destination'
        this.calculate()
      }
    },
    pendingAssetDeposits () {
      const payload = {
        page: 1,
        size: 10,
        status: 'pending', // should be updated to pending later
        type: 'asset_deposit',
        from: '',
        to: ''
      }
      this.getDeposits(payload)
    }
  },
  async beforeMount () {
    if (this.hasKyc) {
      await this.pendingAssetDeposits()
      if (this.exchangeRate === 0) {
        const message = 'Cannot get current exchange rate at the moment'
        this.$message({
          showClose: true,
          message: `${message}, please try again Later`,
          type: 'error',
          duration: 5000
        })
        this.$store.dispatch('common/setError', message)
        setTimeout(() => {
          this.$router.push('system-error')
        }, 3000)
      }
      if (
        this.transferDetails &&
        Object.keys(this.transferDetails).length > 0
      ) {
        this.enteredAmountForm.enteredAmount = this.transferDetails.debitAmount
        this.enteredAmountForm.recipientAmount =
          this.transferDetails.recipientAmount
      }
      if (this.hasBeenDebited) {
        this.openDialog('destination')
      }
      this.getBeneficiaries()
    }
  },
  watch: {
    'enteredAmountForm.enteredAmount': function (newValue) {
      if (!this.firstInputSelected) {
        this.enteredAmountForm.enteredAmount = newValue
      } else {
        const result = newValue
          .toString()
          .split('.')[0]
          .replace(/\D/g, '')
          .replace(/^0+/g, '')
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        this.enteredAmountForm.enteredAmount = result
      }
    },
    'enteredAmountForm.recipientAmount': function (newValue) {
      if (this.firstInputSelected) {
        this.enteredAmountForm.recipientAmount = newValue
      } else {
        const result = newValue
          .toString()
          .split('.')[0]
          .replace(/\D/g, '')
          .replace(/^0+/g, '')
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        this.enteredAmountForm.recipientAmount = result
      }
    },
    '$store.state.transactions.deposits.items': function () {
      if (
        this.$store.state.transactions.deposits.items.length > 0 &&
        !this.hasBeenDebited
      ) {
        this.showPendingAssetTransferDialog = true
      }
    },
    deep: true
  }
}
</script>

<style scoped>
>>> .el-select {
  width: 110px;
  margin-right: -30px;
}

>>> .el-select .el-input .el-select__caret {
  color: var(--color-primary);
  font-size: 13px;
  font-weight: 800;
  transition: transform 0.3s;
  transform: rotateZ(180deg);
  cursor: pointer;
}
>>> .form-item {
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.12),
    0px 1px 3px rgba(3, 2, 7, 0.12);
  border-radius: 15px;
}
.form-item-2 {
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.12),
    0px 1px 3px rgba(3, 2, 7, 0.12);
  border-radius: 15px;
}
.drop-down {
  border-radius: 0px 15px 15px 0px;
}
>>> .el-popper[x-placement^='bottom'] {
  margin-left: -100px;
}
>>> .el-input__inner {
  border: none;
  outline: none;
  padding-right: 0rem;
  background: transparent;
  font-size: 1.6rem;
  font-weight: 700;
}
.form-item-1 ul {
  list-style: none;
  border-left: 1px solid var(--text-3);
}
.form-item-1 li {
  position: relative;
}
.form-item-1 li::before {
  content: '•';
  font-size: 1.8rem;
  position: absolute;
  left: -0.4rem;
  top: 0;
  color: var(--color-primary);
}
.form-item-1 li:last-of-type::before {
  left: -0.5rem;
}

.slide-fade-enter-active {
  animation: slide-fade 0.3s ease forwards;
}
.slide-fade-leave-active {
  animation: slide-fade 0.3s ease forwards alternate-reverse;
}
/* animation for  */
@keyframes slide-fade {
  0% {
    opacity: 0;
    transform: translateY(-20%);
  }
  70% {
    opacity: 0.7;
    transform: translateY(10%);
  }
  100% {
    opacity: 1;
    transform: translateY(0%);
  }
}
/* .continue-button button {
  border-radius: 200px;
} */
@media screen and (max-width: 767px) {
  >>> .el-input__inner {
    font-size: 1.5rem;
  }

  >>> .el-select {
    margin-right: -10px;
    width: 80px;
  }
  >>> .el-select .el-input .el-select__caret {
    margin-right: 0.15rem;
  }
  >>> .el-select .el-input__inner {
    font-size: 1rem;
  }
}
</style>
